<template>
  <div style="margin-top: -20px !important">
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <!-- Header part -->
      <b-row
        class="hidden-sm-down d-print-none px-pad py-2 border-bottom justify-content-center align-items-center"
        style="height: 65px"
      >
        <b-col cols="8" class="text-left px-0">
          <div class="d-flex w-100">
            <span>
              <i class="la la-cube img-circle"></i>
            </span>
            <div class="mx-2 mt-2 w-75">
              <h5 class="mb-1 text-truncate w-100">{{ list.main_detail.pdt_name }}</h5>
              <small class="text-muted fw-semi-bold mb-2">
                <b-badge variant="primary" size="xs" style="height: 20px">
                  {{
                  (list.main_detail.pdt_status == 1 || active_change == true) &&
                  inactive_change != true
                  ? "Active"
                  : "Inactive"
                  }}
                </b-badge>
              </small>
            </div>
          </div>
        </b-col>
        <b-col cols="4" class="text-right px-0">
          <!-- <b-button variant="success" size="sm" >New Invoice</b-button> -->
          <b-button
            variant="primary"
            size="sm"
            class="mr-2"
            v-if="RoutePermission(true, 'ProductCreate', '', '', '')"
            :to="{ name: 'ProductCreate', query:{page_from:'view',old_id:$route.params.id}}"
          >New Product</b-button>
          <b-button-group variant="light">
            <b-button
              size="sm"
              v-if="RoutePermission(false, '', 'invoice', 'product', 'update')"
              :to="{ name: 'ProductUpdate', params: { id: $route.params.id } ,query:{page_from:'view'}}"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>
            <b-button
              variant="light"
              size="sm"
              title="delete"
              v-if="
              list.main_detail.is_used == 0 &&
              RoutePermission(false, '', 'invoice', 'product', 'delete')
            "
              @click="
              handlingapprovingmodal({
                content: 'Are you sure you want to delete this product?',
                title: 'Delete Product - ' + list.main_detail.pdt_name,
                module: 'products/deleteproduct',
                data: JSON.stringify({
                  id: $route.params.id,
                }),
                RoutePlace: 'Product',
                isRoute: 'true',
                type: 'delete',
                route_history: pdt_index_history,
              })
            "
            >
              <i class="glyphicon glyphicon-trash"></i>
            </b-button>
            <b-dropdown
              v-if="RoutePermission(false, '', 'invoice', 'product', 'update')||RoutePermission(true, 'ProductCreate', '', '', '')"
              right
              variant="light"
              no-caret
              size="sm"
              style="height: 33px !important"
            >
              <template slot="button-content">
                <i class="glyphicon glyphicon-option-vertical" style="padding-bottom: 3px"></i>
              </template>
              <b-dropdown-item
                v-if="RoutePermission(false, '', 'invoice', 'product', 'update')"
                @click="
                statusChange();
                status =
                  (list.main_detail.pdt_status == 1 || active_change == true) &&
                  inactive_change != true
                    ? 'inactive'
                    : 'active';
              "
              >
                {{
                (list.main_detail.pdt_status == 1 || active_change == true) &&
                inactive_change != true
                ? "Mark as Inactive"
                : "Mark as Active"
                }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="RoutePermission(true, 'ProductCreate', '', '', '')"
                :to="{
                name: 'ProductCreate',
                query: { clone_id: $route.params.id,page_from:'view'  },
              }"
              >Clone Product</b-dropdown-item>
            </b-dropdown>
            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="pdt_index_history ? pdt_index_history : { name: 'Product' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <!--  Tab Details -->
      <div class="d-flex" style="margin-left: -20px; margin-right: -20px">
        <div class="view-content-block border-left d-none d-lg-block">
          <div class="py-3">
            <!--  Item Details -->
            <h6
              class="fw-semi-bold theme-text-color px-pad"
              style="padding-bottom: 6px"
            >Product Details</h6>
            <div class="border-bottom"></div>

            <b-row class="px-pad py-2">
              <b-col cols="4">Name</b-col>
              <b-col cols="8" class="text-truncate">
                {{
                list.main_detail.pdt_name
                }}
              </b-col>
            </b-row>
            <b-row class="px-pad py-2">
              <b-col cols="4">Type</b-col>
              <b-col cols="8">{{ list.main_detail.pdt_state }}</b-col>
            </b-row>
            <b-row class="px-pad py-2">
              <b-col cols="4">Unit</b-col>
              <b-col cols="8" class="text-truncate">
                {{
                list.main_detail.unit_name
                }}
              </b-col>
            </b-row>
            <div class="border-bottom"></div>

            <h6
              class="fw-semi-bold theme-text-color px-pad"
              style="padding-bottom: 6px; padding-top: 10px"
            >Sales Details</h6>
            <div class="border-bottom"></div>

            <b-row class="px-pad py-2">
              <b-col cols="6">Selling Price</b-col>
              <b-col
                cols="6"
                class="text-truncate"
              >{{orgCurrencySymbol}} {{ parseFloat(list.main_detail.pdt_sal_price) }}</b-col>
            </b-row>

            <!-- <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Sales Account</div>
                  <div class="cus-view-addr w-50">{{list.main_detail.sales_account }}</div>
            </div>-->
            <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.sales_desc">
                  <div class="cus-view-addr w-50 text-muted">Sales Description</div>
                  <div class="cus-view-addr w-50">{{list.main_detail.sales_desc }}</div>
            </div>-->

            <div class="border-bottom"></div>

            <template>
              <b-tabs class="customer_view_tab custom-tab" card>
                <b-tab
                  title="Tax Details"
                  active
                  class="px-pad py-2"
                  title-link-class="text-center"
                >
                  <!-- <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Tax Preference</div>
                  <div
                    class="cus-view-addr w-50"
                  >{{ list.main_detail.tax_preference==0 ?'Tax Exempt':'Taxable'}}</div>
                </div>
                <div class="d-flex w-100 py-2" v-if="list.main_detail.tax_preference==0">
                  <div class="cus-view-addr w-50 text-muted">Exempt Reason</div>
                  <div class="cus-view-addr w-50">{{ list.main_detail.exempt_reason_name}}</div>
                  </div>-->
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                    list.main_detail.tax_details[list.main_detail.pdt_tax_id]
                  "
                  >
                    <div class="cus-view-addr w-50 text-muted">Intra State Tax Rate</div>
                    <div class="cus-view-addr w-50">
                      {{
                      list.main_detail.tax_details[list.main_detail.pdt_tax_id]
                      .tax_name
                      }}
                    </div>
                  </div>
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                    list.main_detail.tax_details[
                      list.main_detail.pdt_inter_tax_id
                    ]
                  "
                  >
                    <div class="cus-view-addr w-50 text-muted">Inter State Tax Rate</div>
                    <div class="cus-view-addr w-50">
                      {{
                      list.main_detail.tax_details[
                      list.main_detail.pdt_inter_tax_id
                      ].tax_name
                      }}
                    </div>
                  </div>
                </b-tab>
                <b-tab
                  title="Additional Details"
                  class="px-pad py-2"
                  title-link-class="text-center"
                >
                  <template
                    v-if="
                    list.main_detail.pdt_hsn ||
                    list.main_detail.pdt_sku ||
                    list.main_detail.pdt_tags
                  "
                  >
                    <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_hsn">
                      <div class="cus-view-addr w-50 text-muted">HSN Code</div>
                      <div class="cus-view-addr w-50">{{ list.main_detail.pdt_hsn }}</div>
                    </div>
                    <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_sku">
                      <div class="cus-view-addr w-50 text-muted">SKU</div>
                      <div class="cus-view-addr w-50">{{ list.main_detail.pdt_sku }}</div>
                    </div>

                    <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_legacy_id">
                    <div class="cus-view-addr w-50 text-muted">Legacy Id</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_legacy_id}}</div>
                    </div>-->
                    <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_tags">
                      <div class="cus-view-addr w-50 text-muted">Product Tags</div>
                      <div class="cus-view-addr w-50">{{ list.main_detail.pdt_tags }}</div>
                    </div>
                    <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_desc">
                    <div class="cus-view-addr w-50 text-muted">Product Notes</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_desc}}</div>
                    </div>-->
                  </template>
                  <template v-else>
                    <span class="text-muted pt-2 pb-2">No additional details to display</span>
                  </template>
                </b-tab>
              </b-tabs>
            </template>
            <template
              v-if="
              reporting_tags.filter(
                (tag) =>
                  list.main_detail[tag.tag_column_name] != '' &&
                  list.main_detail[tag.tag_column_name] != null
              ).length != 0
            "
            >
              <div class="border-bottom"></div>
              <h6
                class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                style="padding-bottom: 6px"
              >Reporting Tags</h6>
              <div class="border-bottom"></div>
              <!--  Selling and ales accountant -->

              <div class="w-100 px-pad">
                <div
                  class="d-flex w-100 py-2"
                  v-for="(tag, index) in reporting_tags"
                  :key="index"
                  v-if="
                  list.main_detail[tag.tag_column_name] != '' &&
                  list.main_detail[tag.tag_column_name] != null &&
                  list.main_detail[tag.tag_column_name] != 0
                "
                >
                  <div class="cus-view-addr w-50 text-muted">{{ tag.tag_name }}</div>

                  <div class="cus-view-addr w-50">
                    {{
                    getJsonPresentValue(
                    tag.tag_options,
                    "value",
                    list.main_detail[tag.tag_column_name],
                    "label"
                    )
                    }}
                  </div>
                </div>
              </div>
            </template>
            <!-- Custom Fields -->
            <template
              v-if="
              pdt_settings_details.custom_field.filter(
                (custom_field) =>
                  list.main_detail[custom_field.field_name] &&
                  custom_field.status == 1 && custom_field.permissions != 'hide'
              ).length != 0
            "
            >
              <div class="border-bottom"></div>
              <h6
                class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                style="padding-bottom: 6px"
              >Custom Fields</h6>
              <div class="border-bottom"></div>

              <div class="w-100 px-pad">
                <b-row
                  class="d-flex w-100 py-2"
                  v-for="custom_field in pdt_settings_details.custom_field"
                  :key="custom_field.id"
                  v-if="
                  list.main_detail[custom_field.field_name] &&
                  custom_field.status == 1 && custom_field.permissions != 'hide'
                "
                >
                  <b-col cols="4">{{ custom_field.label_name }}</b-col>

                  <b-col cols="8" :key="custom_field.id" v-if="custom_field.datatype == 'select'">
                    {{
                    getJsonPresentValue(
                    custom_field.options,
                    "value",
                    list.main_detail[custom_field.field_name],
                    "label"
                    )
                    }}
                  </b-col>
                  <b-col
                    cols="8"
                    :key="custom_field.id"
                    v-else-if="custom_field.datatype == 'date'"
                  >
                    {{
                    getDateFormat(list.main_detail[custom_field.field_name])
                    }}
                  </b-col>
                  <b-col
                    cols="8"
                    :key="custom_field.id"
                    v-else-if="custom_field.datatype == 'amount'"
                  >{{ orgCurrencySymbol +' '+list.main_detail[custom_field.field_name] }}</b-col>
                  <b-col
                    cols="8"
                    class="cus-view-addr w-50"
                    :key="custom_field.id"
                    v-else-if="custom_field.datatype == 'checkbox'"
                  >
                    {{
                    list.main_detail[custom_field.field_name] == 1
                    ? "True"
                    : "False"
                    }}
                  </b-col>
                  <b-col
                    cols="8"
                    class="cus-view-addr w-50"
                    :key="custom_field.id"
                    v-else
                  >{{ list.main_detail[custom_field.field_name] }}</b-col>
                </b-row>
              </div>
            </template>
          </div>
        </div>

        <div class="view-tab-block">
          <b-tabs class="customer_view_tab no-flex-grow mt-2 border-tab">
            <!-- For product View page -->

            <b-tab
              title="Overview"
              active
              :title-link-class="{
              'd-print-none': true,
              'd-block d-lg-none': true,
            }"
              class="p-0 d-print-none"
            >
              <div class="py-3">
                <!--  Item Details -->
                <h6
                  class="fw-semi-bold theme-text-color px-pad"
                  style="padding-bottom: 6px"
                >Product Details</h6>
                <div class="border-bottom"></div>

                <b-row class="px-pad py-2">
                  <b-col cols="4">Name</b-col>
                  <b-col cols="8" class="text-truncate">
                    {{
                    list.main_detail.pdt_name
                    }}
                  </b-col>
                </b-row>
                <b-row class="px-pad py-2">
                  <b-col cols="4">Type</b-col>
                  <b-col cols="8">{{ list.main_detail.pdt_state }}</b-col>
                </b-row>

                <div class="border-bottom"></div>

                <h6
                  class="fw-semi-bold theme-text-color px-pad"
                  style="padding-bottom: 6px; padding-top: 10px"
                >Sales Details</h6>
                <div class="border-bottom"></div>

                <b-row class="px-pad py-2">
                  <b-col cols="6">Selling Price</b-col>
                  <b-col
                    cols="6"
                    class="text-truncate"
                  >{{orgCurrencySymbol}} {{ parseFloat(list.main_detail.pdt_sal_price) }}</b-col>
                </b-row>

                <!-- <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Sales Account</div>
                  <div class="cus-view-addr w-50">{{list.main_detail.sales_account }}</div>
                </div>-->
                <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.sales_desc">
                  <div class="cus-view-addr w-50 text-muted">Sales Description</div>
                  <div class="cus-view-addr w-50">{{list.main_detail.sales_desc }}</div>
                </div>-->

                <div class="border-bottom"></div>

                <template>
                  <b-tabs class="customer_view_tab custom-tab" card>
                    <b-tab
                      title="Tax Details"
                      active
                      class="px-pad py-2"
                      title-link-class="text-center"
                    >
                      <!-- <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Tax Preference</div>
                  <div
                    class="cus-view-addr w-50"
                  >{{ list.main_detail.tax_preference==0 ?'Tax Exempt':'Taxable'}}</div>
                </div>
                <div class="d-flex w-100 py-2" v-if="list.main_detail.tax_preference==0">
                  <div class="cus-view-addr w-50 text-muted">Exempt Reason</div>
                  <div class="cus-view-addr w-50">{{ list.main_detail.exempt_reason_name}}</div>
                      </div>-->
                      <div
                        class="d-flex w-100 py-2"
                        v-if="
                        list.main_detail.tax_details[
                          list.main_detail.pdt_tax_id
                        ]
                      "
                      >
                        <div class="cus-view-addr w-50 text-muted">Intra State Tax Rate</div>
                        <div class="cus-view-addr w-50">
                          {{
                          list.main_detail.tax_details[
                          list.main_detail.pdt_tax_id
                          ].tax_name
                          }}
                        </div>
                      </div>
                      <div
                        class="d-flex w-100 py-2"
                        v-if="
                        list.main_detail.tax_details[
                          list.main_detail.pdt_inter_tax_id
                        ]
                      "
                      >
                        <div class="cus-view-addr w-50 text-muted">Inter State Tax Rate</div>
                        <div class="cus-view-addr w-50">
                          {{
                          list.main_detail.tax_details[
                          list.main_detail.pdt_inter_tax_id
                          ].tax_name
                          }}
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      title="Additional Details"
                      class="px-pad py-2"
                      title-link-class="text-center"
                    >
                      <template
                        v-if="
                        list.main_detail.pdt_hsn ||
                        list.main_detail.pdt_sku ||
                        list.main_detail.pdt_tags
                      "
                      >
                        <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_hsn">
                          <div class="cus-view-addr w-50 text-muted">HSN Code</div>
                          <div class="cus-view-addr w-50">{{ list.main_detail.pdt_hsn }}</div>
                        </div>
                        <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_sku">
                          <div class="cus-view-addr w-50 text-muted">SKU</div>
                          <div class="cus-view-addr w-50">{{ list.main_detail.pdt_sku }}</div>
                        </div>

                        <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_legacy_id">
                    <div class="cus-view-addr w-50 text-muted">Legacy Id</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_legacy_id}}</div>
                        </div>-->
                        <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_tags">
                          <div class="cus-view-addr w-50 text-muted">Product Tags</div>
                          <div class="cus-view-addr w-50">{{ list.main_detail.pdt_tags }}</div>
                        </div>
                        <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_desc">
                    <div class="cus-view-addr w-50 text-muted">Product Notes</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_desc}}</div>
                        </div>-->
                      </template>
                      <template v-else>
                        <span class="text-muted pt-2 pb-2">No additional details to display</span>
                      </template>
                    </b-tab>
                  </b-tabs>
                </template>
                <template
                  v-if="
                  reporting_tags.filter(
                    (tag) =>
                      list.main_detail[tag.tag_column_name] != '' &&
                      list.main_detail[tag.tag_column_name] != null
                  ).length != 0
                "
                >
                  <div class="border-bottom"></div>
                  <h6
                    class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                    style="padding-bottom: 6px"
                  >Reporting Tags</h6>
                  <div class="border-bottom"></div>
                  <!--  Selling and ales accountant -->

                  <div class="w-100 px-pad">
                    <div
                      class="d-flex w-100 py-2"
                      v-for="(tag, index) in reporting_tags"
                      :key="index"
                      v-if="
                      list.main_detail[tag.tag_column_name] != '' &&
                      list.main_detail[tag.tag_column_name] != null &&
                      list.main_detail[tag.tag_column_name] != 0
                    "
                    >
                      <div class="cus-view-addr w-50 text-muted">{{ tag.tag_name }}</div>

                      <div class="cus-view-addr w-50">
                        {{
                        getJsonPresentValue(
                        tag.tag_options,
                        "value",
                        list.main_detail[tag.tag_column_name],
                        "label"
                        )
                        }}
                      </div>
                    </div>
                  </div>
                </template>
                <!-- Custom Fields -->
                <template
                  v-if="
                  pdt_settings_details.custom_field.filter(
                    (custom_field) =>
                      list.main_detail[custom_field.field_name] &&
                      custom_field.status == 1
                  ).length != 0
                "
                >
                  <div class="border-bottom"></div>
                  <h6
                    class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                    style="padding-bottom: 6px"
                  >Custom Fields</h6>
                  <div class="border-bottom"></div>

                  <div class="w-100 px-pad">
                    <b-row
                      class="d-flex w-100 py-2"
                      v-for="custom_field in pdt_settings_details.custom_field"
                      :key="custom_field.id"
                      v-if="
                      list.main_detail[custom_field.field_name] &&
                      custom_field.status == 1
                    "
                    >
                      <b-col cols="4">{{ custom_field.label_name }}</b-col>

                      <b-col
                        cols="8"
                        :key="custom_field.id"
                        v-if="custom_field.datatype == 'select'"
                      >
                        {{
                        getJsonPresentValue(
                        custom_field.options,
                        "value",
                        list.main_detail[custom_field.field_name],
                        "label"
                        )
                        }}
                      </b-col>
                      <b-col
                        cols="8"
                        :key="custom_field.id"
                        v-else-if="custom_field.datatype == 'date'"
                      >
                        {{
                        getDateFormat(list.main_detail[custom_field.field_name])
                        }}
                      </b-col>
                      <b-col
                        cols="8"
                        :key="custom_field.id"
                        v-else-if="custom_field.datatype == 'amount'"
                      >{{ orgCurrencySymbol +' '+list.main_detail[custom_field.field_name] }}</b-col>
                      <b-col
                        cols="8"
                        class="cus-view-addr w-50"
                        :key="custom_field.id"
                        v-else-if="custom_field.datatype == 'checkbox'"
                      >
                        {{
                        list.main_detail[custom_field.field_name] == 1
                        ? "True"
                        : "False"
                        }}
                      </b-col>
                      <b-col
                        cols="8"
                        class="cus-view-addr w-50"
                        :key="custom_field.id"
                        v-else
                      >{{ list.main_detail[custom_field.field_name] }}</b-col>
                    </b-row>
                  </div>
                </template>
              </div>
            </b-tab>

            <b-tab
              title="Transactions"
              active
              :title-link-class="{ 'd-print-none': true }"
              class="p-0 d-print-none"
            >
              <template
                v-if="!RoutePermission(false, '', '', 'invoice', 'index')&&!RoutePermission(false, '', '', 'credit', 'index')&&!RoutePermission(false, '', '', 'paymentsreceived', 'index')&&!RoutePermission(false, '', '', 'quotation', 'index')"
              >
                <p
                  class="p-4 px-pad text-muted"
                >You do not have permission to perform view transcations. Please contact your Administrator.</p>
              </template>
              <div v-else role="tablist" class="px-pad py-3">
                <template v-if="RoutePermission(false, '', '', 'quotation', 'index')">
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="quotation_table"
                      @click="
                    getList(
                      'fetchproductquotationview',
                      1,
                      10,
                      'quotationCollapse'
                    )
                  "
                    >
                      <span
                        :class="{
                      'fa fa-caret-right': !quotationCollapse,
                      'fa fa-caret-down': quotationCollapse,
                      'pb-1 pr-2': true,
                    }"
                      ></span>QUOTATION
                    </div>

                    <b-collapse id="quotation_table" v-model="quotationCollapse" role="tabpanel">
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Quotation</th>
                                <th>Customer</th>
                                <th class="text-right">QTY</th>
                                <th class="text-right">Unit Price</th>
                                <th class="text-right">Total</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                              typeof quotation_list.quotation_list ==
                                'undefined' ||
                              quotation_list == '' ||
                              quotation_list.quotation_list.length == 0
                            "
                              >
                                <tr>
                                  <td colspan="7" class="text-center">No data to display</td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr
                                  v-for="item in quotation_list.quotation_list"
                                  :key="item.sal_hdr_id"
                                >
                                  <td>{{ getDateFormat(item.quot_created_date) }}</td>
                                  <td
                                    v-if="
                                  RoutePermission(
                                    false,
                                    '',
                                    'invoice',
                                    'quotation',
                                    'index'
                                  )
                                "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                    name: 'SalesView',
                                    params: { id: item.sal_hdr_id },
                                  }"
                                    >{{ item.quot_no }}</router-link>
                                  </td>
                                  <td v-else>{{ item.quot_no }}</td>
                                  <td>{{ item.cus_name }}</td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.pdt_qty
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.unit_price
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.total
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td>{{ item.quot_status_name }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                        typeof quotation_list.quotation_list != 'undefined' &&
                        quotation_list.quotation_list.length > 0
                      "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                            parseInt(quotation_list.page) == 1
                              ? 'pointer-events:none;opacity : 0.8'
                              : ''
                          "
                              class="page-item"
                              @click="
                            getPaginationList(
                              'fetchproductquotationview',
                              parseInt(quotation_list.page) - 1,
                              10
                            )
                          "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                              (quotation_list.page - 1) * quotation_list.show +
                              1 || 0
                              }}
                              to
                              {{
                              (quotation_list.page - 1) * quotation_list.show +
                              quotation_list.quotation_list.length
                              }}
                            </li>
                            <li
                              :style="
                            parseInt(quotation_list.next_record) == 0
                              ? 'pointer-events:none;opacity : 0.8'
                              : ''
                          "
                              class="page-item"
                              @click="
                            getPaginationList(
                              'fetchproductquotationview',
                              parseInt(quotation_list.page) + 1,
                              10
                            )
                          "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('quotation')"
                        >
                          Total Count :
                          {{ total_quotation_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <hr />
                </template>
                <template v-if="RoutePermission(false, '', '', 'invoice', 'index')">
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="invoice_table"
                      @click="
                    getList('fetchproductinvoiceview', 1, 10, 'invoiceCollapse')
                  "
                    >
                      <span
                        :class="{
                      'fa fa-caret-right': !invoiceCollapse,
                      'fa fa-caret-down': invoiceCollapse,
                      'pb-1 pr-2': true,
                    }"
                      ></span>INVOICE
                    </div>

                    <b-collapse id="invoice_table" v-model="invoiceCollapse" role="tabpanel">
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Invoice</th>
                                <th>Customer</th>
                                <th class="text-right">QTY</th>
                                <th class="text-right">UNit Price</th>
                                <th class="text-right">Total</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                              typeof invoice_list.invoice_list == 'undefined' ||
                              invoice_list == '' ||
                              invoice_list.invoice_list.length == 0
                            "
                              >
                                <tr>
                                  <td colspan="7" class="text-center">No data to display</td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr v-for="(item, index) in invoice_list.invoice_list" :key="index">
                                  <td>{{ getDateFormat(item.created_date) }}</td>
                                  <td
                                    v-if="
                                  RoutePermission(
                                    false,
                                    '',
                                    'invoice',
                                    'invoice',
                                    'index'
                                  )
                                "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                    name: 'InvoiceView',
                                    params: { id: item.inv_hdr_id },
                                  }"
                                    >{{ item.inv_no }}</router-link>
                                  </td>
                                  <td v-else>{{ item.inv_no }}</td>
                                  <td>{{ item.cus_name }}</td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.pdt_qty
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.unit_price
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.total
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td>{{ item.inv_status_name }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                        typeof invoice_list.invoice_list != 'undefined' &&
                        invoice_list.invoice_list.length > 0
                      "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                            parseInt(invoice_list.page) == 1
                              ? 'pointer-events:none;opacity : 0.8'
                              : ''
                          "
                              class="page-item"
                              @click="
                            getPaginationList(
                              'fetchproductinvoiceview',
                              parseInt(invoice_list.page) - 1,
                              10
                            )
                          "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                              (invoice_list.page - 1) * invoice_list.show + 1 || 0
                              }}
                              to
                              {{
                              (invoice_list.page - 1) * invoice_list.show +
                              invoice_list.invoice_list.length
                              }}
                            </li>
                            <li
                              :style="
                            parseInt(invoice_list.next_record) == 0
                              ? 'pointer-events:none;opacity : 0.8'
                              : ''
                          "
                              class="page-item"
                              @click="
                            getPaginationList(
                              'fetchproductinvoiceview',
                              parseInt(invoice_list.page) + 1,
                              10
                            )
                          "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('invoice')"
                        >
                          Total Count :
                          {{ total_invoice_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                  <hr />
                </template>
                <!--  Recurring invoice-->
                <template v-if="RoutePermission(false, '', '', 'credit', 'index')">
                  <!-- Credit -->
                  <div no-body style="display: flow-root">
                    <!--  Invoice and its details -->
                    <div
                      block
                      href="#"
                      variant="light"
                      style="cursor: pointer"
                      aria-controls="credit_table"
                      @click="
                    getList('fetchproductcreditview', 1, 10, 'creditCollapse')
                  "
                    >
                      <span
                        :class="{
                      'fa fa-caret-right': !creditCollapse,
                      'fa fa-caret-down': creditCollapse,
                      'pb-1 pr-2': true,
                    }"
                      ></span>CREDIT
                    </div>

                    <b-collapse id="credit_table" v-model="creditCollapse" role="tabpanel">
                      <b-card-body>
                        <div class="table-responsive">
                          <!--  Invoice Table-->
                          <table class="table table-hover">
                            <!--  Invoice Table head-->
                            <thead style="background: #fbfbfb">
                              <tr>
                                <th>Date</th>
                                <th>Credit</th>
                                <th>Customer</th>
                                <th class="text-right">QTY</th>
                                <th class="text-right">UNit Price</th>
                                <th class="text-right">Total</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <!--  Invoice Table body and data -->
                            <tbody>
                              <template
                                v-if="
                              typeof credit_list.credit_list == 'undefined' ||
                              credit_list == '' ||
                              credit_list.credit_list.length == 0
                            "
                              >
                                <tr>
                                  <td colspan="7" class="text-center">No data to display</td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr v-for="(item, index) in credit_list.credit_list" :key="index">
                                  <td>{{ getDateFormat(item.crdt_date) }}</td>
                                  <td
                                    v-if="
                                  RoutePermission(
                                    false,
                                    '',
                                    'invoice',
                                    'credit',
                                    'index'
                                  )
                                "
                                  >
                                    <router-link
                                      class="text-link"
                                      :to="{
                                    name: 'CreditView',
                                    params: { id: item.crdt_hdr_id },
                                  }"
                                    >{{ item.crdt_no }}</router-link>
                                  </td>
                                  <td v-else>{{ item.crdt_no }}</td>
                                  <td>{{ item.cus_name }}</td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.pdt_qty
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.unit_price
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                    parseFloat(
                                    item.total
                                    ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })
                                    }}
                                  </td>
                                  <td>{{ item.crdt_status_name }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <nav
                          class="float-right"
                          v-if="
                        typeof credit_list.credit_list != 'undefined' &&
                        credit_list.credit_list.length > 0
                      "
                        >
                          <ul class="pagination" style="cursor: pointer">
                            <li
                              :style="
                            parseInt(credit_list.page) == 1
                              ? 'pointer-events:none;opacity : 0.8'
                              : ''
                          "
                              class="page-item"
                              @click="
                            getPaginationList(
                              'fetchproductcreditview',
                              parseInt(credit_list.page) - 1,
                              10
                            )
                          "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-left mr-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                            <li class="page-item">
                              {{
                              (credit_list.page - 1) * credit_list.show + 1 || 0
                              }}
                              to
                              {{
                              (credit_list.page - 1) * credit_list.show +
                              credit_list.credit_list.length
                              }}
                            </li>
                            <li
                              :style="
                            parseInt(credit_list.next_record) == 0
                              ? 'pointer-events:none;opacity : 0.8'
                              : ''
                          "
                              class="page-item"
                              @click="
                            getPaginationList(
                              'fetchproductcreditview',
                              parseInt(credit_list.page) + 1,
                              10
                            )
                          "
                            >
                              <span
                                aria-hidden="true"
                                class="fw-semi-bold fa fa-angle-right ml-2"
                                style="margin-bottom: 4px"
                              ></span>
                            </li>
                          </ul>
                        </nav>
                        <span
                          class="float-left text-link fw-semi-bold"
                          style="cursor: pointer"
                          @click="getTotalCount('credit')"
                        >
                          Total Count :
                          {{ total_credit_list.total_count || "" }}
                        </span>
                      </b-card-body>
                    </b-collapse>
                  </div>
                </template>
              </div>
            </b-tab>
            <b-tab
              title="PriceList view"
              class="p-0 d-print-none"
              v-if="RoutePermission(false, '', '', 'pricelists', 'index')&&
          list.pricing_list_sales.length > 0 
        "
            >
              <b-tabs class="customer_view_tab no-flex-grow mt-4 p-4" pills small>
                <!-- <b-button-group size="sm" class="mb-3">
                <b-button
                  :pressed="pricing_list == 'sales_details'"
                  :variant="
                    pricing_list == 'sales_details' ? 'primary' : 'light'
                  "
                  @click="pricing_list = 'sales_details'"
                >Sales</b-button>
                </b-button-group>-->

                <!-- <h5 class="mt-5 mb-3">Stock Locations</h5> -->
                <div style="max-width: 900px !important" class="mb-5 mt-3">
                  <table
                    class="table table-bordered sales-table last-child-border-none total-table"
                  >
                    <thead>
                      <th class="text-left">Name</th>
                      <th class="text-right">Pricing Range</th>
                      <th class="text-right">Price</th>
                      <th class="text-right" style="border: none; background: none !important"></th>
                    </thead>
                    <tbody
                      v-if="
                      (pricing_list == 'sales_details' &&
                        list.pricing_list_sales.length > 0) ||
                      (pricing_list == 'purchase_details' &&
                        list.pricing_list_purchase.length > 0)
                    "
                    >
                      <tr
                        v-for="(item, index) in pricing_list == 'sales_details'
                        ? list.pricing_list_sales
                        : list.pricing_list_purchase"
                        :key="item.id"
                      >
                        <td class="text-left" style="max-width: 300px !important">
                          <span class="text">{{ item.pricing_name }}</span>
                        </td>
                        <td class="text-right text-truncate">{{ item.pricing_range }}</td>
                        <td
                          class="text-right"
                          v-if="pricelistedit == true"
                          style="max-width: 100px"
                        >
                          <div class="d-flex">
                            <span class="pr-2 pt-2">{{ orgCurrencySymbol }}</span>
                            <input type="text" class="form-control" v-model="item.pricing_rate" />
                          </div>
                        </td>
                        <td
                          class="text-right"
                          v-else
                          style="max-width: 100px"
                        >{{item.pricing_rate?orgCurrencySymbol+' '+ item.pricing_rate:'' }}</td>
                        <td v-if="pricelistedit == false" style="border: none !important">
                          <i
                            v-if="RoutePermission(false, '', '', 'pricelists', 'update')"
                            class="la la-edit la-lg text-primary cursor_pointer"
                            @click="
                            (pricelistedit = true), (button_id = index);
                            pricingrate_old = item.pricing_rate;
                          "
                          ></i>
                        </td>
                        <td
                          v-else-if="(pricelistedit = true)"
                          style="border: none; max-width: 100px"
                        >
                          <i
                            class="fa fa-spinner fa-spin"
                            style="font-size: 18px"
                            v-if="submitted === index"
                          ></i>
                          <b-button
                            variant="success"
                            size="sm"
                            @click="SubmitPricing(index)"
                            v-else-if="!submitted && button_id === index"
                            style="
                            height: 23px !important;
                            width: 23px !important;
                            border-radius: 50% !important;
                          "
                          >
                            <i
                              class="la la-check la-lg"
                              style="position: relative; left: -7px; top: -4px"
                            ></i>
                          </b-button>
                          <b-button
                            variant="light"
                            size="sm"
                            v-if="button_id === index"
                            @click="
                            button_id = '';
                            item.pricing_rate = pricingrate_old;
                            pricelistedit = false;
                          "
                            class="ml-2"
                            style="
                            height: 23px !important;
                            width: 23px !important;
                            border-radius: 50% !important;
                          "
                          >
                            <i
                              class="la la-remove la-lg"
                              style="position: relative; left: -8px; top: -4px"
                              @click="
                              item.pricing_rate = pricingrate_old;
                              pricelistedit = false;
                            "
                            ></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td
                          colspan="3"
                          class="text-center"
                          v-if="
                          pricing_list == 'purchase_details' &&
                          list.pricing_list_purchase.length > 0
                        "
                        >
                          The purchase price lists associated with this product
                          will be displayed here
                        </td>
                        <td colspan="3" class="text-center" v-else>
                          The sales price lists associated with this product will
                          be displayed here
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tabs>
            </b-tab>
          </b-tabs>

          <!--  Recurring invoice-->
        </div>
      </div>

      <statuschange
        module="products"
        :statuschange="status"
        :id="list.main_detail.pdt_id"
        :status="list.main_detail.pdt_status"
        @status_change="
        list.main_detail.pdt_status == 1
          ? (list.main_detail.pdt_status = 0)
          : (list.main_detail.pdt_status = 1)
      "
        @active_status="activechange()"
        @inactive_status="inactivechange()"
      ></statuschange>
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :type="globalmodaltype"
        :route_history="route_history"
      />
    </template>
  </div>
</template>
<script>
import getPageTitle from "@/utils/get-page-title"; // to set page title
import RecordNotFound from "@/pages/Error/RecordNotFound";
import Widget from "@/components/Widget/Widget";
import { mapState, mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notification";
import statuschange from "@/components/Modal/Product/StatusChangeModal";
import store from "@/store/index";
export default {
  mixins: [notificationMixin],
  components: {
    Widget,
    statuschange,
    RecordNotFound
  },
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      content: "",
      status: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      invoiceCollapse: false,
      quotationCollapse: false,
      creditCollapse: false,
      active_change: false,
      inactive_change: false,
      button_id: "",
      pricing_list: "sales_details",
      pricingrate_old: "",
      pricelistedit: false,
      route_history: ""
    };
  },
      beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Product",
        stg_name: "pdt_settings_details"
      }).then(() => {
      
      next();
    });
  },
  methods: {
    SubmitPricing(index) {
      var data;
      this.submitted = index;
      data = {
        id:
          this.pricing_list == "sales_details"
            ? this.list.pricing_list_sales[index].pricing_itm_id
            : this.list.pricing_list_purchase[index].pricing_itm_id,
        pricing_rate:
          this.pricing_list == "sales_details"
            ? this.list.pricing_list_sales[index].pricing_rate
            : this.list.pricing_list_purchase[index].pricing_rate
      };
      this.$store.dispatch("products/pricelistedit", data).then(response => {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: response.data.type,
          showCloseButton: true
        });
        this.pricelistedit = false;
        this.submitted = "";
      });
    },
    async getTotalCount(type) {
      await store.dispatch("products/viewtotalcount", {
        id: this.$route.params.id,
        type: type
      });
      this[type] = true;
    },
    statusChange() {
      this.$root.$emit("bv::show::modal", "statuschange");
    },
    activechange() {
      this.active_change = true;
      this.inactive_change = false;
    },
    inactivechange() {
      this.inactive_change = true;
    },
    //  delete whole product
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    async getList(url, page, show, type) {
      if (this[type] == false) {
        const Vpage = page || 1;
        const Vshow = show || 10;
        await store.dispatch("products/" + url, {
          page: Vpage,
          show: Vshow,
          id: this.$route.params.id
        });
        this[type] = true;
      } else {
        this[type] = false;
      }
    },
    async getPaginationList(url, page, show) {
      const Vpage = page || 1;
      const Vshow = show || 10;
      await store.dispatch("products/" + url, {
        page: Vpage,
        show: Vshow,
        id: this.$route.params.id
      });
    }
  },
  created() {
    if (this.status_code != 404) {
      document.title = getPageTitle(
        this.list.main_detail.pdt_name + " | " + this.$route.meta.title
      );
    }
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      list: state => state.products.listView,
      code: state => state.products.code,
      invoice_list: state => state.products.invoice_list,
      quotation_list: state => state.products.quotation_list,
      credit_list: state => state.products.credit_list,
      total_invoice_list: state => state.products.total_invoice_list,
      total_quotation_list: state => state.products.total_quotation_list,
      total_credit_list: state => state.products.total_credit_list,
      status_code: state => state.products.status_code,
      status_message: state => state.products.status_message,
      status_type: state => state.products.status_type,
      pdt_index_history: state => state.products.pdt_index_history
    }),
    ...mapGetters([
      "pdt_settings_details",
      "reporting_tags",
      "orgCurrencySymbol"
    ])
  }
};
</script>


